const getApiBaseUrl = () => {
  let base = ""
  if (process.env.REACT_APP_ENV === "production") {
    base = "https://qarabao-api.sumenismo.com/"
  } else if (process.env.REACT_APP_ENV === "staging") {
    base = "https://qarabao-api.sumenismo.com/"
  } else if (process.env.REACT_APP_ENV === "dev") {
    base = "https://qarabao-api.sumenismo.com/"
  } else {
    base = "https://qarabao-api.sumenismo.com/"
  }
  return base
}

export default getApiBaseUrl
